/** The time zone of the server's day boundaries, date parsing, and rendering, which must not depend on `TZ`. */
export const SERVER_TIME_ZONE = 'Asia/Tokyo';

export const isServer = !('window' in globalThis);

/** The `timeZone` option for `Intl` formatters: the server's on the server, the browser's in the browser. */
export const displayTimeZone: string | undefined = isServer ? SERVER_TIME_ZONE : undefined;
